import { FontPreviewWithTag } from "pages/media/brandkit/components/FontPreviewWithTag";
import { FontPreviewText } from "pages/media/brandkit/components/FontPreview";
import { useTranslate } from "#src/hooks";
import { FontItem, FONT_SOURCES } from "../types";

/** Script tags (lowercased) shown as a label next to a font, with their i18n key. */
const TAG_LABEL_KEYS: Record<string, string> = {
  arabic: "components.FontSelect.arabic",
  cyrillic: "components.FontSelect.cyrillic",
  chinese: "components.FontSelect.chinese",
};

interface FontPreviewProps {
  fontItem: FontItem;
  showWeight?: boolean;
  style?: React.CSSProperties;
  hideTag?: boolean;
}

export const FontPreview = ({
  fontItem,
  showWeight = false,
  style = { fontSize: 14, padding: 0, textAlign: "left" },
  hideTag = false,
}: FontPreviewProps) => {
  const t = useTranslate();
  const { font, source, weight, prettyName, hasName } = fontItem;

  const displayText =
    showWeight && weight
      ? weight
      : !hasName
        ? t("components.FontSelect.example")
        : showWeight
          ? weight || "Regular"
          : prettyName;

  if (source === FONT_SOURCES.BRANDKIT) {
    let purposeKey = "";
    if ("purpose" in font) {
      purposeKey = font.purpose;
      if (purposeKey === "Text") {
        purposeKey = "Paragraph";
      }
    }
    const typeLabel = t(
      `components.templates.settings.textTab.textTypes.${purposeKey.toLowerCase()}`
    );
    const previewText = `${typeLabel} : ${displayText}`;
    return font.path ? (
      <FontPreviewText font={font.path} text={previewText} style={style} />
    ) : null;
  }

  if (source === FONT_SOURCES.PUBLIC) {
    const tags = "tags" in font ? font.tags : undefined;
    const labelKey = tags
      ?.map((tag) => TAG_LABEL_KEYS[tag.toLowerCase()])
      .find(Boolean);

    if (labelKey && !hideTag) {
      return (
        <FontPreviewWithTag
          fontPath={font.path ?? ""}
          text={displayText}
          label={t(labelKey)}
          fontSize={(style.fontSize as number) || 14}
        />
      );
    }

    return (
      <FontPreviewText
        font={font.path ?? ""}
        text={displayText}
        style={style}
      />
    );
  }

  return font.path ? (
    <FontPreviewText font={font.path} text={displayText} style={style} />
  ) : null;
};
